import { inject } from 'inversify';
import { Injectable } from '../../decorators/injectable';
import { HttpService, type IHttpService } from '../http/http.service';
import type { IPermissionService, PermissionsResponse } from './permission.service.interface';

@Injectable()
export class PermissionService implements IPermissionService {
  constructor(@inject(HttpService) private readonly http: IHttpService) {}

  async getMyPermissions(): Promise<PermissionsResponse> {
    return this.http.get<PermissionsResponse>('permissions/me');
  }
}
